import { Component, inject } from '@angular/core';
import { ActivatedRoute, Data, Router } from "@angular/router";
import { RouterUtils } from "@danangelus/ngx-utils";
import { Links, LinksPage } from "../../models/static-pages.model";

/**
 * Series of links pages
 *
 * @author Dan Bennett
 */
@Component({
    selector: 'app-links-page',
    templateUrl: './links-page.component.html',
    styleUrl: './links-page.component.sass'
})
export class LinksPageComponent {

    private router = inject(Router)
    private route = inject(ActivatedRoute)

    page: LinksPage | undefined

    constructor() {
        RouterUtils.retrieveData(this.router, this.route, (data: Data) => {
            const type = data['content']
            this.page = Links.content(type)
        })
    }
}
